import { useState, useEffect, useCallback } from 'react';
import { userService } from '../services/api';

export interface SpiritualStats {
  totalReadings: number;
  consecutiveDays: number;
  referralsCount: number;
  achievementsUnlocked: string[];
  referralCode: string;
  achievementsDef: { key: string; label: string; icon: string; threshold: number | null; streak?: number; tokens: number; desc: string }[];
}

export interface NewAchievement {
  key: string;
  label: string;
  icon: string;
  tokens: number;
}

const DEFAULT_STATS: SpiritualStats = {
  totalReadings: 0,
  consecutiveDays: 0,
  referralsCount: 0,
  achievementsUnlocked: [],
  referralCode: '',
  achievementsDef: [],
};

/**
 * Carrega as estatísticas de progresso do usuário (tiragens, dias seguidos,
 * conquistas, indicações). Compartilhado entre Dashboard e Perfil.
 */
export function useSpiritualStats() {
  const [stats, setStats] = useState<SpiritualStats>(DEFAULT_STATS);
  const [newAchievements, setNewAchievements] = useState<NewAchievement[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await userService.getStats();
      setStats({
        totalReadings: data.total_readings,
        consecutiveDays: data.consecutive_days,
        referralsCount: data.referrals_count,
        achievementsUnlocked: data.achievements_unlocked,
        referralCode: data.referral_code,
        achievementsDef: data.achievements_def,
      });
      if (data.new_achievements?.length > 0) {
        setNewAchievements(data.new_achievements);
      }
    } catch {
      // Sem dados de progresso ainda
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { stats, newAchievements, loading, reload: load };
}
